var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232,68H204V56a12.01312,12.01312,0,0,0-12-12H64A12.01312,12.01312,0,0,0,52,56V68H23.87305a12.01312,12.01312,0,0,0-12,12V96a36.04061,36.04061,0,0,0,36,36h7.019C63.59082,162.9707,91.07129,186.14331,124,187.88477V220H96a4,4,0,0,0,0,8h64a4,4,0,0,0,0-8H132V187.89246A76.03728,76.03728,0,0,0,201.33545,132H208a36.04061,36.04061,0,0,0,36-36V80A12.01312,12.01312,0,0,0,232,68ZM47.87305,124a28.03145,28.03145,0,0,1-28-28V80a4.004,4.004,0,0,1,4-4H52v35.0957A77.50675,77.50675,0,0,0,53.09814,124Zm128.03027,36.2627a67.62228,67.62228,0,0,1-48.41992,19.73535C90.27344,179.72266,60,148.81348,60,111.0957V56a4.004,4.004,0,0,1,4-4H192a4.004,4.004,0,0,1,4,4v56A67.53194,67.53194,0,0,1,175.90332,160.2627ZM236,96a28.03146,28.03146,0,0,1-28,28h-4.94922A77.00466,77.00466,0,0,0,204,112V76h28a4.004,4.004,0,0,1,4,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.c153e29ca08622968625438d1842739c.svg";
export { ForwardRef as ReactComponent };